<template>
  <div id="Inicio">
    <b-form @submit.stop.prevent>
      <b-row class="col-12 col-lg-10 mx-auto row mt-4 mb-4">
        <InformacionListaDeEspera />
        <b-col
          cols="12"
          md
          order="0"
          order-md="1"
          class="d-flex align-items-stretch"
        >
          <div
            class="h6 text-center rounded text-white px-0 bg-azul-medio w-100"
          >
            <div
              class="text-azul-medio text-uppercase gilmer h4 bg-white mx-0 pt-3 pb-2 font-weight-bold"
            >
              Descarga tu comprobante
            </div>
            <div class="gilmer mt-4 text-uppercase h5">Ingresa al Sistema</div>
            <div class="form-group mx-4 mx-lg-5 mt-4 text-left">
              <label for="run" class="mb-1">RUN apoderado</label>
              <b-input
                data-testid="run"
                v-model="rut"
                id="run"
                type="text"
                class="form-control form-control-lg placeholder"
                placeholder="21.123.456-1"
                :state="tieneError('rut')"
                @keyup.once="modificado.push('rut')"
                @change="validarRut('rut', rut)"
                @keyup="formatoRut('rut', rutPostulante)"
                maxlength="13"
                autocomplete="off"
              />
              <div class="mensaje-error" v-show="errorRut">
                {{ this.mensajeError("rut") }}
              </div>
            </div>
            <div class="form-group mx-4 mx-lg-5 mt-4 text-left">
              <label for="password" class="mb-1">Contraseña</label>
              <b-input
                data-testid="clave"
                v-model="usuario.clave"
                id="password"
                type="password"
                class="form-control form-control-lg placeholder"
                placeholder="Contraseña"
                :state="this.tieneError('pass')"
                @keyup.once="modificado.push('pass')"
                @change="validarPassword('pass', usuario.clave)"
                autocomplete="off"
              />
              <div class="mensaje-error" v-show="errorPass">
                {{ this.mensajeError("pass") }}
              </div>
            </div>
            <div class="form-group mx-4 mx-lg-5 mt-4 text-left">
              <label for="run" class="mb-1">RUN postulante</label>
              <b-input
                data-testid="rutPostulante"
                v-model="rutPostulante"
                id="rutPostulante"
                type="text"
                class="form-control form-control-lg placeholder"
                placeholder="21.123.456-1"
                :state="tieneError('rutPostulante')"
                @keyup.once="modificado.push('rutPostulante')"
                @change="validarRut('rutPostulante', rutPostulante)"
                @keyup="formatoRut('rutPostulante', rutPostulante)"
                maxlength="13"
                autocomplete="off"
              />
              <div class="mensaje-error" v-show="errorRutPost">
                {{ this.mensajeError("rutPostulante") }}
              </div>
            </div>
            <router-link
              data-testid="button-olvido-contrasena"
              to="olvido-contrasena"
              class="font-weight-bold text-white subrayado"
              >Olvid&eacute; mi contrase&ntilde;a</router-link
            >
            <div class="d-block mx-4 mx-lg-5 mt-4 mb-4">
              <InvisibleRecaptcha
                v-if="captchaHabilitado"
                data-test="button-login-captcha"
                id="logincaptcha"
                :sitekey="siteKey"
                :validate="validarCredenciales"
                :callback="captcha"
                theme="light"
                class="btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100"
                type="submit"
                >Ingresar</InvisibleRecaptcha
              >
            </div>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ApiLogin from "@/services/ApiLogin";
import ApiResultados from "@/services/ApiResultados";
import Axios from "@/utils/axiosJWT.js";
import { manejoErrores } from "@/assets/js/manejoErrores";
import Validador from "@/assets/js/validador";
import FormateaRut from "@/assets/js/formatoRut";
import InvisibleRecaptcha from "@/components/generales/recaptcha/InvisibleRecaptcha";
import { faRoute } from "@fortawesome/free-solid-svg-icons";
import InformacionListaDeEspera from "@/components/generales/InformacionListaDeEspera";
import { MensajesDeCarga } from "@/utils/BusesDeEventos.js";
import ApiDirectorio from "@/services/ApiDirectorio";
export default {
  mixins: [manejoErrores],
  components: {
    InvisibleRecaptcha,
    InformacionListaDeEspera
  },
  data() {
    return {
      usuario: {
        run: "",
        clave: "",
        runPostulante: ""
      },
      config: {
        headers: {},
        params: {}
      },
      siteKey: RECAPTCHA_PUBLIC_KEY,
      runPostulante: "",
      rut: "",
      rutPostulante: "",
      errorRutPost: false,
      errorRut: false,
      errorPass: false,
      tiempoToken: 15 * 60 * 1000,
      ayuda: PLATAFORMA.AYUDA,
      captchaHabilitado: RECAPTCHA_HABILITADO,
      modoRecuperarPassword: ""
    };
  },
  created() {
    const exist = this.$ss.get("jwt");
    if (exist && exist.length > 0) {
      this.$ss.clear();
    }
    this.obtieneParametros();
  },
  methods: {
    async obtieneParametros() {
      try {
        const tokenBearer =
          "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
        const etapaValor = await ApiDirectorio.obtenerInformacion(
          this,
          tokenBearer
        );
        if (etapaValor.parametroModoRecuperarPassword) {
          localStorage.setItem(
            "modoRecuperarPassword",
            etapaValor.parametroModoRecuperarPassword.valor
          );
        } else {
          console.error("No se obtuvieron correctamente los parametros.");
        }
      } catch (error) {
        console.error("Error al cargar los parametros:", error);
      }
    },
    async captcha(recaptchaToken) {
      if (recaptchaToken) {
        this.config.headers = {
          "g-recaptcha-response": recaptchaToken
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        await this.loguear();
      }
      this.emitCargado();
    },
    emitCargar() {
      MensajesDeCarga.$emit("cargar");
    },
    emitCargado() {
      MensajesDeCarga.$emit("cargado");
    },
    validarCredenciales() {
      this.emitCargar();
      this.modificado = ["rut", "pass", "rutPostulante"];
      let valido = [
        this.validarRut("rut", this.rut),
        this.validarRut("rutPostulante", this.rutPostulante),
        this.validarPassword()
      ];
      let validado = true;
      if (valido.includes(false)) {
        validado = false;
        this.emitCargado();
      }
      return validado;
    },
    formatoRut(campo, valor) {
      if (campo === "rut") {
        this.rut = FormateaRut.formateaRut(this.rut);
      } else {
        this.rutPostulante = FormateaRut.formateaRut(this.rutPostulante);
      }
    },
    validarRut(campo, valor) {
      let valido = true;
      this.limpiarError(campo);
      if (valor.length < 1) {
        this.guardarError(campo, "Ingrese su RUN.");
        valido = false;
      } else if (
        !Validador.validarExpresion("rut", valor) ||
        !FormateaRut.digitoVerificador(valor)
      ) {
        this.guardarError(campo, "El Run no es válido");
        valido = false;
      }
      if (campo === "rut") {
        this.errorRut = false;
      } else if (campo === "rutPostulante") {
        this.errorRutPost = false;
      }
      if (valido) {
        if (campo === "rut") {
          this.usuario.run = parseInt(
            valor
              .slice(0, -1)
              .split(".")
              .join("")
              .replace("-", "")
          );
        } else if (campo === "rutPostulante") {
          this.runPostulante = parseInt(
            valor
              .slice(0, -1)
              .split(".")
              .join("")
              .replace("-", "")
          );
        }
      } else {
        if (campo === "rut") {
          this.errorRut = true;
        } else if (campo === "rutPostulante") {
          this.errorRutPost = true;
        }
      }
      return valido;
    },
    validarPassword() {
      let valido = true;
      let errores = [];
      let campo = "pass";
      let valor = this.usuario.clave;
      this.limpiarError(campo);
      this.errorPass = false;
      if (valor.length < 1) {
        errores.push("Ingrese su contraseña");
      } else if (valor.length < 8) {
        errores.push("Contraseña no válida");
      }
      if (errores.length > 0) {
        this.guardarError(campo, errores[0]);
        this.errorPass = true;
        valido = false;
      }
      return valido;
    },
    //TODO: Revisar que el jwt se mantenga en el sessionstrogae, porque cuando se cambia de dominio se pierde
    async loguear() {
      this.emitCargar();
      this.usuario.runPostulante = this.runPostulante;
      let loguear = await ApiLogin.loguearUsuario(
        this.usuario,
        this,
        this.config
      );
      if (loguear) {
        Axios.configurarJWT(loguear);
        this.$ss.set("jwt", loguear);
        this.$router.push({
          name: "Comprobantes",
          params: { runPostulante: this.runPostulante }
        });
      } else {
        this.usuario.run = "";
        this.rut = "";
        this.usuario.clave = "";
        this.emitCargado();
      }
    }
  }
};
</script>
<style scoped>
.mensaje-error {
  margin-top: -3px;
  padding: 0.5rem 1rem;
  background-color: #f7edeb;
  color: #dc3545 !important;
  border: 1px solid #dc3545 !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Inicio.vue